<template>
  <div id="multibook-list">
    <div
      class="multibook-list-items"
      :key="'multibook-list-item-' + index"
      v-for="(it, index) in homePageData.multibooks"
      :class="{ 'multibook-list-item-disable': it.disable }"
      @click="goTo(it.name, it.router, it.disable)"
    >
      <div v-if="it.name != currentRoute">
        <p>
          <span>{{ index + 1 }}.</span>{{ it.title }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../../config/homePage/homePage.js';
export default {
  name: 'multibook-list',

  data: function() {
    return {
      homePageData: null,
      //   currentRoute: '',
    };
  },

  beforeMount() {
    this.init();
  },
  methods: {
    redirectDev(type) {
      this.$router.push(`/${type}`);
    },
    init() {
      console.log(home);
      this.homePageData = home;
      //   this.currentRoute = this.$router.currentRoute.name;
    },
    goTo(id, router, disable) {
      if (!disable) {
        if (router && router != 'main_book-view') {
          this.$store.commit('CHANGE_MULTIBOOK_TYPE', id);
          this.$router.push({ name: router });
        } else if (router === 'main_book-view') {
          this.$router.push({ name: router, params: { runBook: process.env.MAIN_BOOK_PATH } });
        } else {
          this.$emit('goTo', id);
        }
      }
    },
  },
  computed: {
    currentRoute() {
      return this.$store.getters.multibookType;
    },
  },
};
</script>

<style lang="sass">
$break-large: 1400px
#multibook-list
  z-index: 99999
  padding: 24px
  top: 84px
  left: 216px
  max-height: 40%
  background: white
  font-size: 1rem
  position: absolute
  border-radius: 10px 10px 0 0
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset
  .multibook-list-items
    cursor: pointer
    &:hover
      text-shadow: 0 0 9px #7d6e00
    span
        text-align: left
        font-size: 1rem
        margin-letf: 24px
        margin-right: 24px
    p
        text-align: left
        font-size: 1rem
  .multibook-list-item-disable
    cursor: auto !important
    &:hover
      text-shadow: 0 0 9px transparent !important
</style>
